<script lang="ts">
	import noSocialIcon from 'assets/svg/noSocialIcon.svg?url';
	import twitter from 'assets/svg/twitter.svg?url';
	import reddit from 'assets/svg/reddit.svg?url';
	import facebook from 'assets/svg/facebook.svg?url';
	import website from 'assets/svg/link.svg?url';
	import telegram from 'assets/svg/telegram.svg?url';
	import type { IExchangeSocial } from 'src/types/exchange';

	export let dark = false;
	export let data: IExchangeSocial;
	export let backupLink: string;
	export let ref: string;
	$: exchangeLink = ref || data?.url || backupLink;

	function getLinkName(url: string) {
		const lastPart = url
			.split('/')
			.filter((part) => part !== '')
			.pop();
		return lastPart.replace(/[^a-zA-Z0-9]/g, '');
	}

	function processTwitterLink(profileName: string) {
		const link = profileName ? `https://twitter.com/${profileName}` : '';
		return link;
	}

	function getPlatformName(url: string) {
		let platformName = '';
		const parts = new URL(url).hostname.split('.');

		if (parts[0] === 'www') {
			platformName = parts[1];
		} else {
			platformName = parts[0];
		}
		return platformName;
	}
</script>

<div class="wrapper" class:dark>
	{#if !data?.url && !backupLink}
		<p class="no-links">no external links found</p>
	{/if}
	<ul class="link-list">
		{#if data?.url || backupLink}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={website} alt="Website" />
					<p class="name">Website</p>
				</div>
				<a target="_blank" rel="noreferrer" href={exchangeLink} class="link"
					>{exchangeLink ? new URL(exchangeLink).hostname : ''}</a
				>
			</li>
		{/if}

		{#if data?.facebook_url}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={facebook} alt="Facebook" />
					<p class="name">Facebook</p>
				</div>
				<a target="_blank" rel="noreferrer" href={data.facebook_url} class="link"
					>{getLinkName(data.facebook_url)}</a
				>
			</li>
		{/if}

		{#if data?.twitter_handle}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={twitter} alt="Twitter" />
					<p class="name">Twitter</p>
				</div>
				<a target="_blank" rel="noreferrer" href={processTwitterLink(data.twitter_handle)} class="link"
					>{getLinkName(processTwitterLink(data.twitter_handle))}</a
				>
			</li>
		{/if}

		{#if data?.reddit_url}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={reddit} alt="Reddit" />
					<p class="name">Reddit</p>
				</div>
				<a target="_blank" rel="noreferrer" href={data.reddit_url} class="link"
					>{getLinkName(data.reddit_url)}</a
				>
			</li>
		{/if}

		{#if data?.telegram_url}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={telegram} alt="Telegram" />
					<p class="name">Telegram</p>
				</div>
				<a target="_blank" rel="noreferrer" href={data.telegram_url} class="link"
					>{getLinkName(data.telegram_url)}</a
				>
			</li>
		{/if}

		{#if data?.other_url_1}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={noSocialIcon} alt="Social" />
					<p class="name">{getPlatformName(data.other_url_1)}</p>
				</div>
				<a target="_blank" rel="noreferrer" href={data.other_url_1} class="link"
					>{getLinkName(data.other_url_1)}</a
				>
			</li>
		{/if}

		{#if data?.other_url_2}
			<li class="link-list-item">
				<div class="name-wrapper">
					<img class="social-logo" src={noSocialIcon} alt="Social2" />
					<p class="name">{getPlatformName(data.other_url_2)}</p>
				</div>
				<a target="_blank" rel="noreferrer" href={data.other_url_2} class="link"
					>{getLinkName(data.other_url_2)}</a
				>
			</li>
		{/if}
	</ul>
</div>

<style lang="scss">
	@import 'exchangeLinks';
</style>
